module.exports = __webpack_public_path__ + "img/shortlistweb.55f67ca8.webp";